/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Ebr_Diff_Words_AddedInputs */

const cs_ebr_diff_words_added = /** @type {(inputs: Ebr_Diff_Words_AddedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} slov`)
};

const en_ebr_diff_words_added = /** @type {(inputs: Ebr_Diff_Words_AddedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} words`)
};

/**
* | output |
* | --- |
* | "{count} words" |
*
* @param {Ebr_Diff_Words_AddedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_diff_words_added = /** @type {((inputs: Ebr_Diff_Words_AddedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Diff_Words_AddedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_diff_words_added(inputs)
	return cs_ebr_diff_words_added(inputs)
});